import { render, staticRenderFns } from "./Ranking1.vue?vue&type=template&id=b64f193a&scoped=true"
import script from "./Ranking1.vue?vue&type=script&lang=js"
export * from "./Ranking1.vue?vue&type=script&lang=js"
import style0 from "./Ranking1.vue?vue&type=style&index=0&id=b64f193a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64f193a",
  null
  
)

export default component.exports